import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EngagementStatus } from '../../models/engagement-status.model';
import { Nomination } from '../../models/nomination.model';
import { SelectCustomer } from '../../models/select-customer.model';
import { SelectUsageByPartner } from '../../models/select-usage-by-partner.model';
import { ValidateUsageEngagement } from '../../models/validate-usage-engagement.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerUsageService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  searchCustomer(tId: string, AN: string): Observable<SelectCustomer[]> {
    return this.http.get<SelectCustomer[]>(
      this.settings.baseUrl +
        'api/CustomerUsage/GetSelectUsageTenantId/TId/' +
        tId +
        '/AN/' +
        AN
    );
  }

  getAllEngagements(
    tId: string,
    AN: string
  ): Observable<ValidateUsageEngagement[]> {
    return this.http.get<ValidateUsageEngagement[]>(
      this.settings.baseUrl +
        'api/CustomerUsage/ValidateUsageEngagementDetails/TId/' +
        tId +
        '/AN/' +
        AN
    );
  }

  getEligibleEngagementStatus(
    tId: string,
    AN: string
  ): Observable<EngagementStatus[]> {
    return this.http.get<EngagementStatus[]>(
      this.settings.baseUrl +
        'api/CustomerUsage/SelectUsagestatusDetails/TId/' +
        tId +
        '/AN/' +
        AN
    );
  }

  getSelectUsageByPartner(
    tId: string,
    AN: string
  ): Observable<SelectUsageByPartner[]> {
    return this.http.get<SelectUsageByPartner[]>(
      this.settings.baseUrl +
        'api/CustomerUsage/SelectUsageStatusDetailsByPartner/TId/' +
        tId +
        '/AN/' +
        AN
    );
  }

  getAllNominations(tId: string, AN: string): Observable<Nomination[]> {
    return this.http.get<Nomination[]>(
      this.settings.baseUrl +
        'api/CustomerUsage/SelectUsageAllEngagementdetailsByTenantId/TId/' +
        tId +
        '/AN/' +
        AN
    );
  }
}
